export function getFilterText(count: number) {
	if (!count) return "Ничего не найдено"
	return `Найдено ${count} вариантов`
}
